<template>
  <v-main>
    <AllOperationsDialogs ref="allOps" />
    <AdjustCCAndProduct ref="adjustCCAndProductDialog" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :selectable="true"
      @rowClicked="showRowDetails"
      :limits="[5, 10, 20, 50, 100, 200]"
      rememberLastClick
      @update:selected="(ids) => (selectedIds = ids)"
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <OMenuButton :menuOpts="menuOpts" />
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import AllOperationsDialogs from '../clients/operations/AllOperationsDialogs.vue'
import AdjustCCAndProduct from '../clients/operations/AdjustCCAndProduct.vue'
import { translateType } from '@/models/client-history.js'
import { ClientHistory } from '@/models'

export default {
  pageTitle: 'Histórico de Módulos',
  components: {
    GenericReport,
    AllOperationsDialogs,
    AdjustCCAndProduct
  },
  data() {
    return {
      reportSpec: {
        code: 'globalClientHistory',
        title: 'Histórico de Módulos',
        apiBase: '/history',
        filters: [
          { type: 'HistoryType', prefix: 'types', noSuffix: true },
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar cancelados',
            defVal: false
          }
          // {
          //   type: 'Keywords',
          //   prefix: 'keywords',
          //   icon: 'mdi-magnify'
          // }
          // { type: 'Org', prefix: 'org' }
        ]
      },

      adapterSpec: {
        defaultSortable: false,
        columns: [
          { t: 'ID|', d: 'id' },
          { t: 'Módulo|', d: 'clientId' },
          { t: 'Veículo', d: 'vehicle.code' },
          { t: 'Org', d: 'org.label' },
          {
            t: 'Timestamp',
            d: 'timestamp',
            dataType: 'date',
            format: 'DD/MM/YYYY HH:mm'
          },
          { t: 'Tipo', d: (row) => translateType(row) },
          { t: 'Login', d: 'login' },
          { t: 'Centro de Custo', d: 'costCenter.name' }
        ],
        rowExtraFieldsFn: ({ extraFields, row }) => {
          extraFields.historyType = row.type
          extraFields.historySubType = row.subType
          extraFields.clientId = row.clientId
        }
      },
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      return [
        // {
        //   text: 'Exportar Excel',
        //   icon: 'mdi-file-excel',
        //   onClick: () => this.$refs.report.checkDownload()
        // },
        {
          text: 'Cancelar registros...',
          icon: 'mdi-delete',
          disabled: this.selectedIds.length < 1,
          onClick: () => this.doCancelMany()
        },
        {
          text: 'Alterar CC/produto...',
          icon: 'mdi-delete',
          disabled: this.selectedIds.length < 1,
          onClick: () => this.doChangeMany()
        }
      ]
    }
  },
  methods: {
    async showRowDetails({ row }) {
      let res = await this.$refs.allOps.startEdit(row)
      if (res === 'RELOAD') this.$refs.report.reload()
    },
    async doCancelMany() {
      let len = this.selectedIds.length
      let res = await this.$confirm({
        title: 'Confirmar Remoção em Lote',
        message: `Tem certeza que deseja remover ${len} registros?`,
        cancelText: 'Não, cancelar',
        okText: 'Sim, remover'
      })

      if (res) {
        this.$rootLoading(async () => {
          for (let id of this.selectedIds) {
            await ClientHistory.delete(id)
          }
          this.$snack(`${len} registros removidos com sucesso`)
          this.$refs.report.reload()
        })
      }
    },

    async doChangeMany() {
      let historyIds = this.selectedIds
      let res = await this.$refs.adjustCCAndProductDialog.open({ historyIds })

      if (res === 'RELOAD') {
        this.$refs.report.reload()
      }
    }
  }
}
</script>

<style></style>
